$(function () {
    $("body").on("form:saved", function (e, data) {
        if (data.hasOwnProperty('task') && data.hasOwnProperty('status')) {
            let msgText;
            if (data.status === 'complete') {
                msgText = "Thank you for submitting your " + data.task +
                    " for your upcoming trip!";
            } else {
                msgText = "You have successfully saved a draft of your " + data.task +
                    ". Don&apos;t forget to come back and complete the form as soon as possible.";
            }
            const msgHtml = `
            <p>${msgText}</p>
            <p>If you have any questions or concerns please be sure to reach out to your wildlife safari coordinator
            so they can help you.</p>
            In the meantime, let&rsquo;s connect and inspire your adventure!
            <ul>
            <li>
            <strong>Follow us</strong> on
            <a href="https://www.facebook.com/Cheesemans" target="_blank">Facebook</a>,
            <a href="https://www.instagram.com/cheesemansecologysafaris/?hl=en" target="_blank">Instagram</a>,
            <a href="https://x.com/cheesemanseco" target="_blank">Twitter/X</a>,
            and <a href="https://www.linkedin.com/company/cheesemans" target="_blank">LinkedIn</a>
            for stunning photos, updates, and behind-the-scenes stories from our trips.
            </li>
            <li>
                <strong>Subscribe to</strong> <a href="https://www.youtube.com/user/CheesemansEcology" target="_blank">our YouTube Channel</a>
                to explore videos about your destination and other incredible places we visit.
            </li>
            <li>
            <strong>Check out</strong> <a href="https://cheesemansecologysafaris.smugmug.com/" target="_blank">our SmugMug Galleries</a>
            for a collection of breathtaking trip photos that will spark your excitement!
            </li>
            </ul>
            <p>Your journey is just beginning, and we can&rsquo;t wait to share it with you!</p>
            <p>Cheers!<br>Cheesemans&apos; Ecology Safaris Staff</p>`;
            $('#message-text').html(msgHtml);
            $('#message').addClass('alert-success').show("slow");
        }
    });
});
